export const mainCodeV = `import { createApp } from 'vue';
import App from './App.vue';
createApp(App).mount('#app');
`

export const appCodeV = `<template>
  <pano/>
</template>

<script>
import Pano from './Pano.vue'
export default {
  name: "App",
  components: {
    Pano
  },
  data() {
    return {};
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
</style>`

// 模型渲染
export const initModelCodeV = `<template>
  <div id="container"></div>
</template>

<script>
/**
* npm引入
* import { Meshviewer, ProgressAPI } from '@ali/tide-wanhuatong-sdk/editor';
* import SpotTagPlugin from '@ali/tide-wanhuatong-sdk/plugins/spotTag.js';
* import AiTourPlugin from '@ali/tide-wanhuatong-sdk/plugins/aiTour.js';
*
*/

/**
* script资源引入
* const { Meshviewer, ProgressAPI } = TideWanhuatong;
* const { AiTourPlugin, SpotTagPlugin } = TideWanhuatongPlugins;
*/
import roamingConfig from './mockData/roamingConfig';
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const { Application } = Meshviewer;
const { AiTourPlugin, SpotTagPlugin } = TideWanhuatongPlugins;
export default {
  name: "iniModel",
  props: ["multiFloor", "openSTG", "openAITG"],
  emits: ["getApp"],
  components: {},
  data() {
    return {};
},
methods: {
  async init() {
    const rootPath = this.multiFloor
      ? "https://lyj-public.aliyuncdn.com/pano_test/A.e.retWb91RhFTNo5Si/"
      : "https://lyj-public.aliyuncdn.com/pano_test/A.e.wrWWWXh7H0CEQxNi/";
    const configResolver = {
      resolve: async (relativePath) => {
        switch (relativePath) {
          case "config.json":
            const configModelDataPath =
              rootPath + "config.json" + "?ver=" + Date.now();
            const configModelData = await axios.get(configModelDataPath);
            return configModelData.data;
          case "orthomap/orthomap.json":
            const orthsmapDataPath =
              rootPath + "orthomap/orthomap.json" + "?ver=" + Date.now();
            const orthsMapData = await axios.get(orthsmapDataPath);
            return orthsMapData.data;
          default:
            break;
        }
      },
    };
    const container = document.getElementById("container");
    const resourcesResolver = {
      resolve: async (relativePath) => {
        const url = rootPath + relativePath + "?ver=" + Date.now();
        return url;
      },
    };
    const _app = new Application(container, {
      config: configResolver,
      publicResourceResolver: resourcesResolver,
      privateResourceResolver: resourcesResolver,
      renderOption: {
        preserveDrawingBuffer: true,
      },
    });
    if (this.openSTG) {
      _app.use(new SpotTagPlugin(), "SpotTagPlugin", { lineLength: 4.5 });
    }
    if (this.openAITG) {
      _app.use(new AiTourPlugin(), "AiTourPlugin", roamingConfig);
    }
    ProgressAPI.event.on("AppInitEnd", () => {
      console.log("AppInitEnd");
    });
    ProgressAPI.event.on("ResourceLoadEnd", () => {
      console.log("ResourceLoadEnd");
    });
    this.$emit("getApp", _app);
    _app.start().then(() => {});
    },
  },

  async mounted() {
    await this.init();
  },
};
</script>

<style>
#container {
  height: 420px;
  width: 100%;
  display: flex;
  position: relative;
}
</style>
`

// 模型渲染
export const panoCodeV = `<template>
  <ini-model
    :multiFloor="multiFloor"
    :openSTG="openSTG"
    :openAITG="openAITG"
    @getApp="getApp"
  ></ini-model>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
  name: "Pano",
  components: {
    iniModel,
    app: null,
  },
  methods: {
    getApp(app) {
      this.app = app;
    },
  },
  mounted(){
    ProgressAPI.event.on('SceneLoadEnd', async () => {
      //...
    })
  },
  data() {
    return {
      multiFloor: false,
      openSTG: false,
      openAITG: false,
    };
  },
};
</script>

<style>

</style>`;

// 场景切换
export const transitionCodeV = `<template>
  <ini-model
    :multiFloor="multiFloor"
    :openSTG="openSTG"
    :openAITG="openAITG"
    @getApp="getApp"
  ></ini-model>
  <button id="to3DView">鸟瞰视图</button>
  <button id="toTopView">俯瞰视图</button>
  <button id="toPanoramaView">全景视图</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
  name: "Pano",
  components: {
    iniModel,
    app: null,
  },
  methods: {
    getApp(app) {
      this.app = app;
    },
  },
  mounted() {
    ProgressAPI.event.on('SceneLoadEnd', async () => {
      const transitionAPI = this.app.getInstance("transitionControlAPI");
      transitionAPI.event.on("toTopView", () => {
        console.log("切换到top视图", 111111111);
      });
      transitionAPI.event.on("toNormalView", () => {
        console.log("切换到normal视图", 222222222);
      });
      transitionAPI.event.on("toSpot", (spot, floor) => {
        console.log("切换到全景图", spot, floor);
      });

      document.getElementById("to3DView").onclick = async function (e) {
        transitionAPI.switchToNormalView();
      };
      document.getElementById("toTopView").onclick = async function (e) {
        transitionAPI.switchToTopView();
      };
      document.getElementById("toPanoramaView").onclick = async function (e) {
        transitionAPI.switchToPanoramaView();
      };
    })
  },
  data() {
    return {
      multiFloor: false,
      openSTG: false,
      openAITG: false,
    };
  },
};
</script>

<style></style>
`
// 热点编辑
export const hotSpotCodeV = `<template>
  <ini-model
    :multiFloor="multiFloor"
    :openSTG="openSTG"
    :openAITG="openAITG"
    @getApp="getApp"
  ></ini-model>
  <button id="startHotAnnotating">开始热点打标</button>
  <button id="deleteAnnotation">删除当前标签</button>
  <button id="hiddenAnnotation">隐藏标签</button>
  <button id="showAnnotation">显示标签</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
  name: "Pano",
  components: {
    iniModel,
    app: null,
  },
  methods: {
    getApp(app) {
      this.app = app;
    },
  },
  mounted() {
    ProgressAPI.event.on('SceneLoadEnd', async () => {
      const elementsAPI = this.app.getInstance("elementsAPI");
      const annotationConfig = {"hot-7eb8972b-13b9-40c7-ad13-12697890d8e4":{"id":"hot-a2376ca6-18c4-43b4-b522-b798561f9d6b","type":"hot","spotId":"p0","info":{"titleConfig":{"content":"热点标签","fontSize":"12px","color":"#fff","backgroundColor":"#000000B3","opacity":1,"showStrategy":"hover"},"iconConfig":{"url":"https://repos3d.cdn.bcebos.com/v1/penglai/es/4.1/point.svg","width":"40px","height":"40px","opacity":1}},"anchor":{"x":-2.806628942489624,"y":4.7847490310668945,"z":1.0771491527557373},"includeSpots":["p0","p1","p2","p3","p4","p5","p6","p7","p8","p9"],"normal":[]}, "image-7990c237-64e0-4630-8fd8-8fe183ff6a67": {"id":"image-7990c237-64e0-4630-8fd8-8fe183ff6a67","type":"image","info":{"mediaRatio":1,"keyValue":"请输入浮层标签标题","src":"https://virutalbuy-public.oss-cn-hangzhou.aliyuncs.com/xuhui/img/%E6%88%AA%E5%B1%8F2022-04-22%20%E4%B8%8B%E5%8D%882.29.48.png","type":"image","muted":true,"strategy":{"visible":{"view":"ALL_SPOTS","condition":[],"distance":30}},"control":true},"scale":{"x":0.2,"y":0.2},"anchor":{"x":-2.5176703929901123,"y":3.420215368270874,"z":1.208158016204834},"includeSpots":["p0","p1","p10","p11","p12","p13","p14","p15","p16","p2","p3","p4","p5","p6","p7","p8","p9"],"global":true,"spotId":"p0","anywhere":true,"rotation":{"x":0,"y":0,"z":0},"mediaType":"IMAGE","renderType":"gl3d","normal":{"x":-1,"y":0,"z":0}}}
      let curAnnotationId = null;
      elementsAPI.init(annotationConfig);
      elementsAPI.event.on("click", (id) => {
        console.log("标签被点击", id);
        curAnnotationId = id;
        const element = elementsAPI.getElementById(id);
        console.log("click element", element);
        element.highlight([255, 0, 0]);
        element.lookAt();
        console.log("element.type", element.type);
        setTimeout(() => {
          element.unhighlight();
        }, 1000);
      });
      elementsAPI.event.on("annotationAdd", async (el) => {
        console.log("标签添加成功", JSON.stringify(el));
        curAnnotationId = el.id;
      });
      elementsAPI.event.on("annotation-no-intersection", () => {
        console.log("打标没找到位置～～～～～～～～");
      });
      elementsAPI.event.on("moving", (el) => {
        console.log("标签移动", el);
      });
      elementsAPI.event.on("moveStart", (el) => {
        const element = elementsAPI.getElementById(el.id);
        console.log("标签移动开始", el);
        element.highlight([255, 0, 0]);
      });
      elementsAPI.event.on("moveEnd", (el) => {
        const element = elementsAPI.getElementById(el.id);
        console.log("标签移动结束", el);
        element.unhighlight();
      });
      document.getElementById("startHotAnnotating").onclick = async function (
        e
      ) {
        elementsAPI.startAnnotating("hot");
      };
      document.getElementById("deleteAnnotation").onclick = async function (
        e
      ) {
        elementsAPI.removeAnnotationById(curAnnotationId);
      };
      document.getElementById("hiddenAnnotation").onclick = async function (
        e
      ) {
        elementsAPI.hiddenAllElement();
      };
      document.getElementById("showAnnotation").onclick = async function (e) {
        elementsAPI.showAllElement();
      };
    });
  },
  data() {
    return {
      multiFloor: false,
      openSTG: false,
      openAITG: false,
    };
  },
};
</script>

<style></style>
`

// 场景标签
export const spotTagCodeV = `<template>
  <ini-model
    :multiFloor="multiFloor"
    :openSTG="openSTG"
    :openAITG="openAITG"
    @getApp="getApp"
  ></ini-model>
  <button id="hideTag">隐藏标签</button>
  <button id="showTag">显示标签</button>
  <button id="showAllTag">显示所有标签</button>
  <button id="hideAllTag">隐藏所有标签</button>
  <button id="setTitle">设置标签的标题</button>
  <button id="visibleByConfig">根据配置的visible显示标签</button>
  <button id="heighLight">高亮标签</button>
  <button id="unhighLight">取消标签高亮</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
  name: "Pano",
  components: {
    iniModel,
    app: null,
  },
  methods: {
    getApp(app) {
      this.app = app;
    },
  },
  mounted() {
    ProgressAPI.event.on('SceneLoadEnd', async () => {
      const transitionAPI = this.app.getInstance("transitionControlAPI");
      transitionAPI.switchToNormalView();
      const spotTagPlugin = this.app.getPlugin("SpotTagPlugin");
      document.getElementById("hideTag").onclick = () => {
        spotTagPlugin.hideTagBySpotId("p5", true);
      };
      document.getElementById("showTag").onclick = () => {
        spotTagPlugin.showTagBySpotId("p5", true);
      };
      document.getElementById("showAllTag").onclick = () => {
        spotTagPlugin.showAllTags();
      };
      document.getElementById("hideAllTag").onclick = () => {
        spotTagPlugin.hideAllTags();
      };
      document.getElementById("visibleByConfig").onclick = () => {
        spotTagPlugin.showAllVisibleTags();
      };
      document.getElementById("setTitle").onclick = () => {
        spotTagPlugin.setTagTitle("p6", 232334434334);
      };
      document.getElementById("heighLight").onclick = () => {
        spotTagPlugin.highLight("p7");
      };
      document.getElementById("unhighLight").onclick = () => {
        spotTagPlugin.unhighLight("p7");
      };
    })
  },
  data() {
    return {
      multiFloor: false,
      openSTG: true,
      openAITG: false,
    };
  },
};
</script>

<style></style>
`

// 智能导览
export const aiTourCodeV = `<template>
  <ini-model
    :multiFloor="multiFloor"
    :openSTG="openSTG"
    :openAITG="openAITG"
    @getApp="getApp"
  ></ini-model>
  <button id="startGudie">开启导览</button>
  <button id="pauseGudie">暂停导览</button>
  <button id="resumeGudie">恢复导览</button>
  <button id="switchToGroupByIndex">根据索引切换导览路线上的点位</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
  name: "Pano",
  components: {
    iniModel,
    app: null,
  },
  methods: {
    getApp(app) {
      this.app = app;
    },
  },
  mounted() {
    ProgressAPI.event.on('SceneLoadEnd', async () => {
      const aiTour = this.app.getPlugin("AiTourPlugin");
      document.getElementById("startGudie").onclick = () => {
        aiTour.start();
      };
      document.getElementById("pauseGudie").onclick = () => {
        aiTour.pause();
      };
      document.getElementById("resumeGudie").onclick = () => {
        aiTour.resume();
      };
      document.getElementById("switchToGroupByIndex").onclick = () => {
        aiTour.switchToGroupByIndex(2);
      };
    })
  },
  data() {
    return {
      multiFloor: false,
      openSTG: false,
      openAITG: true,
    };
  },
};
</script>

<style></style>
`
// 多楼层
export const multiFloorCodeV = `<template>
  <ini-model
    :multiFloor="multiFloor"
    :openSTG="openSTG"
    :openAITG="openAITG"
    @getApp="getApp"
  ></ini-model>
  <button id="selectFloor">选中指定楼层</button>
  <button id="switchToFloor">跳转到全景图中指定楼层</button>
  <button id="switchToNoraml">切换至3d视图</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
  name: "Pano",
  components: {
    iniModel,
    app: null,
  },
  methods: {
    getApp(app) {
      this.app = app;
    },
  },
  mounted() {
    ProgressAPI.event.on('SceneLoadEnd', async () => {
      const transitionAPI = this.app.getInstance("transitionControlAPI"); // 从app上获取api实例
      transitionAPI.switchToNormalView();
      document.getElementById("selectFloor").onclick = () => {
        transitionAPI.selectBuildingFloor("floor_1"); // 选中指定楼层，floorId: "total" | 指定楼层key
      };
      document.getElementById("switchToNoraml").onclick = () => {
        transitionAPI.switchToNormalView();
      };
      document.getElementById("switchToFloor").onclick = () => {
        transitionAPI.switchToFloor("floor_1"); // 选中指定楼层，floorId: "total" | 指定楼层key
      };
    })
  },
  data() {
    return {
      multiFloor: true,
      openSTG: false,
      openAITG: false,
    };
  },
};
</script>

<style></style>
`
//相机
export const cameraCodeV = `<template>
  <ini-model
    :multiFloor="multiFloor"
    :openSTG="openSTG"
    :openAITG="openAITG"
    @getApp="getApp"
  ></ini-model>
  <button id="startHotAnnotating">开始热点打标</button>
  <button id="getCameraParams">获取相机的当前参数</button>
  <button id="setCameraThetaPhi">设置相机的theta phi</button>
  <button id="setCameraFov">切换相机fov</button>
  <button id="setCameraControlEnable">设置相机是否可以操作</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
  name: "Pano",
  components: {
    iniModel,
    app: null,
  },
  methods: {
    getApp(app) {
      this.app = app;
    },
  },
  mounted() {
    ProgressAPI.event.on('SceneLoadEnd',() => {
      const cameraAPI = this.app.getInstance("cameraAPI");
      cameraAPI.cameraParamsChange.on('theta_phi',(params) => {
        console.log('相机theta、phi变化', params)
      })
      cameraAPI.cameraParamsChange.on('fov',(params) => {
        console.log('fov变化', params)
      })
      document.getElementById("getCameraParams").onclick = function (e) {
        console.log(cameraAPI.getCameraParams());
      };
      document.getElementById("setCameraThetaPhi").onclick = function (e) {
        cameraAPI.setCameraThetaPhi(-2.995985904871005, -0.931161845453807);
      };
      document.getElementById("setCameraFov").onclick = function (e) {
        cameraAPI.setCameraFov(30);
      };
      document.getElementById("setCameraControlEnable").onclick = function (e) {
        cameraAPI.setCameraControlEnable(!this.controlEnable);
        this.controlEnable = !this.controlEnable;
      };
    });
  },
  data() {
    return {
      multiFloor: false,
      openSTG: false,
      openAITG: false,
      controlEnable: false
    };
  },
};
</script>

<style></style>
`

// 地面导航点
export const spotCodeV = `<template>
<ini-model
  :multiFloor="multiFloor"
  :openSTG="openSTG"
  :openAITG="openAITG"
  @getApp="getApp"
></ini-model>
<button id="getCurrentSpotId">获取当前spot名称</button>
<button id="getHotSpots">获取场景中所有spot点</button>
<button id="hideAllSpots">隐藏所有点位</button>
<button id="showAllSpots">显示所有点位</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
name: "Pano",
components: {
  iniModel,
  app: null,
},
methods: {
  getApp(app) {
    this.app = app;
  },
},
mounted() {
  ProgressAPI.event.on('SceneLoadEnd',() => {
    const hotSpotAPI = this.app.getInstance("hotSpotAPI");
    hotSpotAPI.event.on("click", (id)=>{
      console.log(id)
    });
    document.getElementById("getCurrentSpotId").onclick = function (e) {
      console.log(hotSpotAPI.getCurrentSpotId());
    };
    document.getElementById("getHotSpots").onclick = function (e) {
      console.log(hotSpotAPI.getHotSpots());
    };
    document.getElementById("hideAllSpots").onclick = function (e) {
      hotSpotAPI.hideAllSpots()
    };
    document.getElementById("showAllSpots").onclick = function (e) {
      hotSpotAPI.showAllSpots()
    };
  });
},
data() {
  return {
    multiFloor: false,
    openSTG: false,
    openAITG: false,
  };
},
};
</script>

<style></style>
`

// 走路机器人
export const personGuideCodeV = `<template>
<ini-model
  :multiFloor="multiFloor"
  :openSTG="openSTG"
  :openAITG="openAITG"
  @getApp="getApp"
></ini-model>
<button id="pause">暂停带看</button>
<button id="resume">恢复带看</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
name: "Pano",
components: {
  iniModel,
  app: null,
},
methods: {
  getApp(app) {
    this.app = app;
  },
},
mounted() {
  ProgressAPI.event.on('SceneLoadEnd',async () => {
    await this.app.loadHdr()
    const personGuiderAPI = this.app.getInstance("personGuiderAPI");
    personGuiderAPI.init('v2', 'v2', {});
    document.getElementById("resume").onclick = function (e) {
      personGuiderAPI.resume();
    };
    document.getElementById("pause").onclick = function (e) {
      personGuiderAPI.pause();
    };
  });
},
data() {
  return {
    multiFloor: false,
    openSTG: false,
    openAITG: false,
  };
},
};
</script>

<style></style>
`

// 飞行导购
export const flyGuideCodeV = `<template>
<ini-model
  :multiFloor="multiFloor"
  :openSTG="openSTG"
  :openAITG="openAITG"
  @getApp="getApp"
></ini-model>
<button id="switchEmotion">切换表情</button>
<button id="setGuiderVisible">设置飞行器的可见状态</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
name: "Pano",
components: {
  iniModel,
  app: null,
},
methods: {
  getApp(app) {
    this.app = app;
  },
},
mounted() {
  ProgressAPI.event.on('SceneLoadEnd',async () => {
    await this.app.loadHdr()
    const flyGuiderAPI = this.app.getInstance("flyGuiderAPI");
    flyGuiderAPI.init('built-in', 'built-in', undefined);
    document.getElementById("switchEmotion").onclick = function (e) {
      flyGuiderAPI.switchEmotion('speak')
    };
    document.getElementById("setGuiderVisible").onclick = function (e) {
      flyGuiderAPI.setGuiderVisible(!this.visible);
      this.visible = !this.visible
    };
  });
},
data() {
  return {
    multiFloor: false,
    openSTG: false,
    openAITG: false,
    visible: true
  };
},
};
</script>

<style></style>
`

// 全景图片
export const initPanoImageCodeV = `<template>
<div id="container"></div>
</template>

<script>
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const { Application } = Meshviewer;
const { AiTourPlugin, SpotTagPlugin } = TideWanhuatongPlugins;
export default {
  name: "iniModel",
  props: [],
  emits: ["getApp"],
  components: {},
  data() {
    return {};
  },
methods: {
  async init() {
    const container = document.getElementById("container");
   
    const _app = new Application(container, {
      sceneType: "panoImage",
      ossParams: {
        oss_path: "oss://lyj-public/pano/A.e.ewQtf6djzPdq6x06",
        endpoint: "oss-cn-hangzhou.aliyuncs.com",
      },
    });
    ProgressAPI.event.on("AppInitEnd", () => {
      console.log("AppInitEnd");
    });
    ProgressAPI.event.on("ResourceLoadEnd", () => {
      console.log("ResourceLoadEnd");
    });
    this.$emit("getApp", _app);
    _app.start().then(() => {});
    },
  },

  async mounted() {
    await this.init();
  },
};
</script>

<style>
#container {
height: 420px;
width: 100%;
display: flex;
position: relative;
}
</style>
`

export const panoImageCodeV = `<template>
<ini-model @getApp="getApp"></ini-model>
<button id="startHotAnnotating">开始热点打标</button>
<button id="startLineAnnotating">开始线标打标</button>
<button id="setCameraRotateRate">设置相机自动旋转速率</button>
<button id="enableCameraAutoRotate">设置相机自动旋转</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
name: "Pano",
components: {
  iniModel,
  app: null,
},
methods: {
  getApp(app) {
    this.app = app;
  },
},
mounted() {
    const elementsAPI = this.app.getInstance('elementsAPI');
    const imageSceneAPI = this.app.getInstance('imageSceneAPI');
    const annotationConfig = {"hot-7eb8972b-13b9-40c7-ad13-12697890d8e4":{"id":"hot-a2376ca6-18c4-43b4-b522-b798561f9d6b","type":"hot","spotId":"p0","info":{"titleConfig":{"content":"热点标签","fontSize":"12px","color":"#fff","backgroundColor":"#000000B3","opacity":1,"showStrategy":"hover"},"iconConfig":{"url":"https://repos3d.cdn.bcebos.com/v1/penglai/es/4.1/point.svg","width":"40px","height":"40px","opacity":1}},"anchor":{"x":-2.806628942489624,"y":4.7847490310668945,"z":1.0771491527557373},"includeSpots":["p0","p1","p2","p3","p4","p5","p6","p7","p8","p9"],"normal":[]}, "image-7990c237-64e0-4630-8fd8-8fe183ff6a67": {"id":"image-7990c237-64e0-4630-8fd8-8fe183ff6a67","type":"image","info":{"mediaRatio":1,"keyValue":"请输入浮层标签标题","src":"https://virutalbuy-public.oss-cn-hangzhou.aliyuncs.com/xuhui/img/%E6%88%AA%E5%B1%8F2022-04-22%20%E4%B8%8B%E5%8D%882.29.48.png","type":"image","muted":true,"strategy":{"visible":{"view":"ALL_SPOTS","condition":[],"distance":30}},"control":true},"scale":{"x":0.2,"y":0.2},"anchor":{"x":-2.5176703929901123,"y":3.420215368270874,"z":1.208158016204834},"includeSpots":["p0","p1","p10","p11","p12","p13","p14","p15","p16","p2","p3","p4","p5","p6","p7","p8","p9"],"global":true,"spotId":"p0","anywhere":true,"rotation":{"x":0,"y":0,"z":0},"mediaType":"IMAGE","renderType":"gl3d","normal":{"x":-1,"y":0,"z":0}}}
    elementsAPI.init(annotationConfig);
    document.getElementById('startHotAnnotating').onclick = async function (e) {
      elementsAPI.startAnnotating('hot');
    };
    document.getElementById('startLineAnnotating').onclick = function (e) {
      elementsAPI.startAnnotating('line');
    };
    document.getElementById('setCameraRotateRate').onclick = function (e) {
      imageSceneAPI.setCameraRotateRate(10);
    };
    document.getElementById('enableCameraAutoRotate').onclick = function (e) {
      imageSceneAPI.enableCameraAutoRotate(!this.enbaleRotate);
      this.enbaleRotate = !this.enbaleRotate;
    };
},
data() {
  return {
    enbaleRotate: false
  };
},
};
</script>

<style></style>
`

// 全景视频
export const initVideoModelCodeV = `<template>
<div id="container"></div>
</template>

<script>
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const { Application } = Meshviewer;
const { AiTourPlugin, SpotTagPlugin } = TideWanhuatongPlugins;
export default {
  name: "iniModel",
  props: [],
  emits: ["getApp"],
  components: {},
  data() {
    return {};
  },
methods: {
  async init() {
    const container = document.getElementById("container");
   
    const _app = new Application(container, {
      sceneType: 'panoVideo',
      videoUrl: "https://virutalbuy-public.oss-cn-hangzhou.aliyuncs.com/xuhui/video/qjsp.mp4",
      isLoop: false,
      rotateOption: {
        // autoRotate: true
      }
    });
    ProgressAPI.event.on("AppInitEnd", () => {
      console.log("AppInitEnd");
    });
    ProgressAPI.event.on("ResourceLoadEnd", () => {
      console.log("ResourceLoadEnd");
    });
    this.$emit("getApp", _app);
    _app.start().then(() => {});
    },
  },

  async mounted() {
    await this.init();
  },
};
</script>

<style>
#container {
height: 420px;
width: 100%;
display: flex;
position: relative;
}
</style>
`
export const panoVideoCodeV = `<template>
<ini-model @getApp="getApp"></ini-model>
<button id="play">播放视频</button>
<button id="pause">暂停视频</button>
<button id="reset">重制视频</button>
<button id="setVideoMuted">设置视频是否禁音</button>
<button id="getTotalTime">获取视频总时长</button>
<button id="getCurrentTime">获取视频当前播放时间</button>
<button id="jumpTo">跳转到视频指定时间</button>
<button id="setVideoUrl">设置播放链接</button>
<button id="setPlaybackRate">设置播放速度</button>
</template>

<script>
import iniModel from "./init-model.vue";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
export default {
name: "Pano",
components: {
  iniModel,
  app: null,
},
methods: {
  getApp(app) {
    this.app = app;
  },
},
mounted() {
  const videoSceneAPI = this.app.getInstance('videoSceneAPI');
  document.getElementById('play').onclick = function (e) {
    videoSceneAPI.play();
  };
  document.getElementById('pause').onclick = function (e) {
    videoSceneAPI.pause();
  };
  document.getElementById('reset').onclick = function (e) {
    videoSceneAPI.reset();
  };
  document.getElementById('setVideoMuted').onclick = function (e) {
    videoSceneAPI.setVideoMuted(!this.isMuted);
    this.isMuted = !this.isMuted
  };
  document.getElementById('getTotalTime').onclick = function (e) {
    console.log('视频总时长',videoSceneAPI.getTotalTime())
  };
  document.getElementById('getCurrentTime').onclick = function (e) {
    console.log('获取视频当前播放时间',videoSceneAPI.getCurrentTime())
  };
  document.getElementById('jumpTo').onclick = function (e) {
    videoSceneAPI.jumpTo(30)
  };
  document.getElementById('setVideoUrl').onclick = function (e) {
    videoSceneAPI.setVideoUrl('https://lyj-public.aliyuncdn.com/pano_src/100070-1358108/video/video.mp4')
  };
  document.getElementById('setPlaybackRate').onclick = function (e) {
    videoSceneAPI.setPlaybackRate(3)
  };
},
data() {
  return {
    isMuted:false
  };
},
};
</script>

<style></style>
`